import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';

import HolidayCalendarForm from '../components/HolidayCalendarForm';
import {HolidayCalendar, HolidayCalendarReq} from '../models';
import { HttpClientError, RequestStatus } from 'http-client';
import {savedStatusOption} from "../../../../helpers/alertLabel";
import {createHolidayCalendar, getHolidayCalendarList, reset, updateHolidayCalendar} from "../holiday.reducer";
import {dateSetTimeToNow} from "../../../../helpers/convert";

const HolidayCalendarDetailPage = ({
    isEdit = false, ...props
}: HolidayCalendarDetailPageProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const isLoading = useAppSelector(
        (state: RootState) => state.holiday.isLoading ?? false
    );
    const singleState = useAppSelector(
        (state: RootState) => state.holiday.singleHolidayCalendar ?? ({} as HolidayCalendar)
    );
    const status = useAppSelector((state: RootState) => state.holiday.holidayCalendarStatus);
    const error = useAppSelector(
        (state: RootState) => state.holiday.error ?? ({} as HttpClientError)
    );

    const onSubmit = (formInput: HolidayCalendarReq) => {
        let _formInput = { ...formInput, type: parseInt(formInput.type as string), date: dateSetTimeToNow(formInput.date)};
        if (isEdit) {
            let _formUpdate = { ..._formInput, id: singleState.id};
            dispatch(updateHolidayCalendar(_formUpdate));
        } else {
            dispatch(createHolidayCalendar(_formInput));
        }
        dispatch(reset());
    };

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(status === RequestStatus.success, error.data?.message)).then(() => {
                dispatch(reset());
                dispatch(getHolidayCalendarList({ skip: 0, take: 10 }));
                props.toggleModal();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <HolidayCalendarForm
                isLoading={isLoading}
                isEdit={isEdit}
                onSubmit={onSubmit}
            />
        </div>
    );
};

export interface HolidayCalendarDetailPageProps {
    isEdit: boolean;
    toggleModal: () => void;
}

export default HolidayCalendarDetailPage;
